module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/5-f3a43f0ae9771e35918490dc8c9d0da8.jpg";